<template>
    <div class="grid">
      <div class="unit one-third col">
        <div class="head">
          DataMapper
        </div>
        <div class="content">
          <a :href="getLink('connectid-datamapper-resources')">Resources</a>
        </div>
      </div>
      <div class="unit one-third col">
        <div class="head">
          About
        </div>
        <div class="content">
          <a :href="getLink('connectid-datamapper')">What we are all about</a>
        </div>
      </div>
      <div class="unit one-third col">
        <div class="head">
          Safe Online ApS
        </div>
        <div class="content">
          <div class="social">
            <a href="https://www.facebook.com/bysafeonline/" target="_blank"><i class="icon-facebook"></i></a>
            <a href="https://twitter.com/BySafeOnline" target="_blank"><i class="icon-twitter"></i></a>
            <a href="https://www.linkedin.com/company/safe-online/" target="_blank"><i class="icon-linkedin"></i></a>
          </div>
          <div>
            K&oslash;bmagergade 22, 2<br/>
            1150 K&oslash;benhavn K<br/>
            Danmark <br />
            CVR: 38589962
          </div>
          <div>
            <a href="https://bysafeonline.com/about-safe-online/contact-us/">Contact support</a><br />
            or call us at <br />
            <a href="tel:+4527772737">+45 2777 2737</a>
          </div>
        </div>
      </div>
      <!-- Google Tag manager code -->
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P5PRJXC" height="0" width="0" style="display:none;visibility:hidden"></iframe>

      <noscript>
        <img height="1" width="1" src="https://www.facebook.com/tr?id=170592076919016&ev=PageView&noscript=1"/>
      </noscript>
    </div>
</template>

<script>
import initTrackers from '@/assets/js/trackers.js'
const basePage = 'https://bysafeonline.com'

export default {
    name: 'foot',
    props: {
        base: {
            type: String,
            default: './'
        },
    },
    data() {
        return {}
    },
    methods: {
        getLink (subPage) {
            return basePage + '/' + subPage
        }
    },
    mounted () {
        if (ARCHII_ENV === 'production') { // don't track local dev visits
            initTrackers()
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/scss/vars.scss';
@import '~cookieconsent/build/cookieconsent.min.css';

footer {
  color: #fff;
  padding: 60px;
  background-color: $color-gray;

  img {
    width: 40px;
  }

  .social {
    a {
      color: $color-blue;
      padding: 5px 10px 5px 0;
    }
  }

  .col {
    font-size: 14px;
    padding-left: 130px !important; // to center them

    .head {
      max-width: 50%;
      padding: 5px 0;
      font-weight: 700;
      color: $color-blue;
      border-bottom: 1px solid;
      text-transform: uppercase;
    }
    .content {
      margin-top: 20px;

      > a {
        color: white;
        margin: 12px 0;
        display: block;
        max-width: 50%;
      }

      div {
        margin: 25px 0;
        line-height: 1.4;

        &:not(.social) > a {
          color: $color-blue;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// apps/comps/footer.vue